import { Header, Icon } from '@iqueue/ui-kit'
import HourlyProductionChart from './HourlyProductionChart'
import ProductionDiffLine from '../ProductionDiffLine'
import { t } from '../../../hooks/useTranslate'
import NodesTrafficLight from '../NodesTrafficLight'
import { UNIT_VOLUME } from '../Measurement'

export default function FieldCard({
  summary: {
    hourlyValue = 0,
    pastHourValue = 0,
    dailyValue = 0,
    pastDayValue = 0,
    monthlyValue = 0,
    pastMonthValue = 0,
  } = {},
  nodes,
  hourlyChart = [],
  type,
  name = 'Field',
  onClick,
}) {
  return <div
    className={ 'gas-and-oil-card interactive' }
    onClick={ onClick }
  >
    <Header
      title={ <>
        <b><Icon filled style={ { marginRight: '0.8rem' } }>water_pump</Icon></b>
        <span>{ name }</span>
      </> }
      extra={ <NodesTrafficLight nodes={ nodes } /> }
      subtitle={ t(`type.node.${ type }`) }
    />

    <div className={ 'content' }>
      <HourlyProductionChart
        hourlyData={ hourlyChart }
        currentHourValue={ hourlyValue }
        pastHourValue={ pastHourValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.dailyProduction') }
        current={ dailyValue }
        past={ pastDayValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.monthlyProduction') }
        current={ monthlyValue }
        past={ pastMonthValue }
        unit={ UNIT_VOLUME }
      />

      {/*<div>*/}
      {/*  <p/>*/}
      {/*  <div>Среднее значение давлений в УКПГ</div>*/}
      {/*  <div>Среднее значение температур у УКПГ</div>*/}
      {/*</div>*/}
    </div>
  </div>
}
